export const RoleCode = {
  ADMIN: 'admin',
  GURU: 'guru',
  KEPALA_SEKOLAH: 'kepala_sekolah',
} as const;

export type RoleCode = (typeof RoleCode)[keyof typeof RoleCode];

export const RoleCodes = [
  RoleCode.ADMIN,
  RoleCode.GURU,
  RoleCode.KEPALA_SEKOLAH,
] as const satisfies RoleCode[];
